<script setup>
import { ref } from 'vue'
const searchText = defineModel()

defineOptions({inheritAttrs: false})

function onEnterKey(event) {
  // if (!searchText.value.trim()) return
  event.target.blur() // remove focus from this input after pressing enter
}

function onFocus(event) {
  event.target.select() // select all text on focus
}

function clearSearch() {
  searchText.value = ''
}
</script>

<template lang="pug">
InputGroup
  InputGroupAddon: i.ph.ph-magnifying-glass
  InputText(
    v-model="searchText"
    :placeholder="$attrs.placeholder || 'Search'"
    @keyup.enter="onEnterKey"
    @focus="onFocus"
  )
  InputGroupAddon: Button(icon="ph ph-x" text severity="secondary" @click="clearSearch")
</template>

<style lang="scss" scoped>
  input:focus {
    background-color: #fffff0;
    border-color: var(--p-inputtext-border-color); // remove border highlighting on focus
  }
  input:enabled:hover {
    border-color: var(--p-inputtext-border-color); // remove hover border color
  }
</style>